import { useState } from 'react'

import { mergeClassName } from '../../utils/mergeClassName'
import { type Quote } from '../../modules/quotes'
import { QuoteComponentContextProvider } from './QuoteComponent.context'
import { type QuoteComponentOptions } from './QuoteComponent.types'
import QuoteHighlightedText from './QuoteHighlightedText'
import Header from './Header'
import Jobs from './Jobs'
import Footer from './Footer'

type QuoteComponentProps = {
  quote: Quote
  options?: QuoteComponentOptions
}

const QuoteComponent: React.FC<QuoteComponentProps> = ({
  quote,
  options,
}) => {
  const [open, setOpen] = useState(!!options?.openByDefault)
  const [selectedJob, setSelectedJob] = useState(0)
  const highlighted = !!options?.highlightedText
  const presentationMode = !!options?.presentationMode
  const cardMode = !!options?.cardMode

  const usCompany = quote.companyBranch.country.toUpperCase() === 'US'
  const useMiles = usCompany

  return (
    <QuoteComponentContextProvider
      open={(open || presentationMode) && !cardMode}
      selectedJob={selectedJob}
      setSelectedJob={setSelectedJob}
      highlighted={highlighted}
      multiJobs={quote.jobs.length > 1 && !options?.jobId}
      nbJobs={quote.jobs.length}
      useMiles={useMiles}
      {...options}
    >
      <div
        className={mergeClassName(
          'relative rounded-2xl border border-gray-200 bg-white p-4 sm:p-8 shadow-lg transition-all duration-200 scale-[0.99] hover:scale-100 hover:shadow-xl',
          open && 'scale-100 shadow-xl border-2 border-gray-300',
          highlighted && 'border-2 border-gray-600',
          (presentationMode || cardMode) && 'rounded-none border-0 shadow-none hover:shadow-none scale-100 hover:scale-100 p-0',
        )}
      >
        <QuoteHighlightedText />
        <Header
          quote={quote}
          onClick={() => { setOpen(!open) }}
        />
        <Jobs quote={quote} />
        <Footer quote={quote} />
      </div>

    </QuoteComponentContextProvider>
  )
}

export default QuoteComponent
